<template>
  <div class="table">
    <div class="container">
     <div>
         <p class="icon-jujue closeBtn" @click="routerBack"></p>
     </div>
     <!-- <div class="handle-box"> -->
          <el-row type="flex"  align="middle">
            <!-- 1-待评分 2-已提交 3-退回 -->
            <el-button v-acl="RMC_PROT_SCORE_SAVE" v-if="detailForm.status==1||detailForm.status==3" size="mini" type="primary" @click="saveData('detailForm')">保存</el-button>
            <el-button v-acl="RMC_PROT_SCORE_SUBMIT" v-if="detailForm.status==1||detailForm.status==3" size="mini"  type="primary" @click="submitData('detailForm')">提交</el-button>
            <el-button v-acl="RMC_PROT_SCORE_APPROVE" v-if="detailForm.status==2" size="mini"  type="primary" @click="cqsSave" >保存</el-button>
            <el-button v-acl="RMC_PROT_SCORE_APPROVE" v-if="detailForm.status==2" size="mini"  type="primary" @click="approve('detailForm')" >批准</el-button>
            <el-button v-acl="RMC_PROT_SCORE_RETURN" v-if="detailForm.status==2" size="mini"  type="primary" @click="rejectBatch">退回</el-button>
          </el-row>
     <!-- </div> -->
    <el-form :model="detailForm" ref="detailForm" :rules="rules" :label-position="labelPosition" label-width="120px" class="searchForm">
    
    <div class="handle-box">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">RMC Protein</p>
        </div>
          <el-row style="margin-top:8px;"  align="middle">
             <el-col :span="6">
                 <el-form-item label="单号" prop="oddNo">
                    <el-input v-model="detailForm.oddNo" disabled placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="评价期" prop="appraisePeriod">
                    <el-select v-model="detailForm.appraisePeriod" disabled clearable  filterable placeholder="请选择(支持多选)" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in allDate" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="detailForm.category3Code" disabled  clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="Sponsor" prop="sponsorName">
                    <el-input v-model="detailForm.sponsorName" disabled placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="ASL" prop="aslName">
                   <el-input v-model="detailForm.aslName" disabled clearable style="width:100%"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="国内/国外" prop="domesticOrOverseas">
                      <el-select v-model="detailForm.domesticOrOverseas" disabled clearable  filterable placeholder="请选择" style="width:100%">
                          <el-option :key="index" v-for="(item,index) in domesticOrOverseas" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="状态">
                     <el-select v-model="detailForm.status" clearable disabled  filterable placeholder="请选择(支持多选)" style="width:100%">
                          <el-option :key="index" v-for="(item,index) in statusList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <!-- <el-form-item label="状态" prop="aslGroup">
                     <el-select v-model="detailForm.aslStatus" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item.name" :value="item.code"></el-option>
                     </el-select>
                 </el-form-item> -->
             </el-col>
             <el-col :span="12">
                 <el-form-item label="退回原因" prop="rejectReason">
                     <el-input v-model="detailForm.rejectReason" disabled placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
          </el-row>
    </div>

    <el-table class="setTable" ref="plxTable" :span-method="arraySpanMethod" :data="detailForm.detailList" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row >
        <el-table-column label="" align="center">
            <el-table-column prop="name" label="Rating Category" align="center" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="wt1View" label="Wt. Food Brand" align="center" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="wt2View" label="Wt. Product" align="center" width="80" show-overflow-tooltip></el-table-column>

            <el-table-column  prop="standard1" label="High" align="center" width="160" show-overflow-tooltip>
                <el-table-column  prop="standard1" label="10" align="center" width="160" show-overflow-tooltip></el-table-column>
            </el-table-column>
            <el-table-column  prop="standard2" label="Medium High" align="center" width="160" show-overflow-tooltip>
                <el-table-column  prop="standard2" label="8" align="center" width="160" show-overflow-tooltip></el-table-column>
            </el-table-column>
            <el-table-column  prop="standard3" label="Medium" align="center" width="160" show-overflow-tooltip>
                <el-table-column  prop="standard3" label="6" align="center" width="160" show-overflow-tooltip></el-table-column>
            </el-table-column>
            <el-table-column  prop="standard4" label="Medium Low" align="center" width="160" show-overflow-tooltip>
                <el-table-column  prop="standard4" label="3" align="center" width="160" show-overflow-tooltip></el-table-column>
            </el-table-column>
            <el-table-column  prop="standard5" label="Low" align="center" width="160" show-overflow-tooltip>
                <el-table-column  prop="standard5" label="0" align="center" width="160" show-overflow-tooltip></el-table-column>
            </el-table-column>
        </el-table-column>

        <!-- 供应商评分&Facts -->
        <el-table-column label="供应商自评" align="center">
            <el-table-column prop="supplierScore1" :label="'Food Brand Association|(whole company)'" :render-header="renderheader" align="center" min-width="120" >
              <template slot-scope="scope">
                 <el-form-item  v-if="(detailForm.status==1||detailForm.status==3)&&scope.$index!=detailForm.detailList.length-1&&scope.$index!=detailForm.detailList.length-2&&isSet" :prop="'detailList.' + scope.$index + '.supplierScore1'"  :rules="scope.row.wt1?rules.supplierScore1:''" >
                   <el-input  @input="scope.row.supplierScore1=scope.row.supplierScore1.replace(/[^\d]/g,'')" @blur="setCurrent(scope.row,1)" v-model="scope.row.supplierScore1" :disabled="scope.row.wt1?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
                 <span v-else>{{scope.row.supplierScore1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="supplierScore2" :label="'Product Safety|(McDssupplyonly)'" :render-header="renderheader" align="center" min-width="120" >
                <template slot-scope="scope">
                  <el-form-item v-if="(detailForm.status==1||detailForm.status==3)&&scope.$index!=detailForm.detailList.length-1&&scope.$index!=detailForm.detailList.length-2&&isSet"  :prop="'detailList.' + scope.$index + '.supplierScore2'"  :rules="scope.row.wt2?rules.supplierScore2:''" >
                      <el-input @input="scope.row.supplierScore2=scope.row.supplierScore2.replace(/[^\d]/g,'')" @blur="setCurrent(scope.row,2)" v-model="scope.row.supplierScore2" :disabled="scope.row.wt2?false:true" placeholder="请输入内容"></el-input>
                  </el-form-item>
                  <span v-else>{{scope.row.supplierScore2}}</span>
              </template>
            </el-table-column>
            <el-table-column  prop="supplierFacts" label="Facts" align="center" width="160" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-form-item v-if="(detailForm.status==1||detailForm.status==3)&&scope.$index!=detailForm.detailList.length-1&&scope.$index!=detailForm.detailList.length-2&&isSet"  :prop="'detailList.' + scope.$index + '.supplierFacts'"  :rules="rules.supplierFacts" >
                   <el-input class="stretchNone"  type="textarea" maxlength="1000"  :autosize="{ minRows: 4, maxRows: 4}" :rows="4"  v-model="scope.row.supplierFacts" style="width:100%">
                   </el-input>
                   <i v-if="scope.row.parentId?true:false"  @click.stop="openDialog(scope.row,scope.$index)" style="position:absolute;right:10px;bottom:10%" class="el-icon-edit-outline"></i>
                  <!-- <el-input  v-model="scope.row.supplierFacts"  placeholder="请输入内容" type="textarea" maxlength="1000" show-word-limit :rows="3" :autosize="{minRows:3}"></el-input> -->
                </el-form-item>
                <el-tooltip v-else class="item" effect="dark" :content="scope.row.supplierFacts" placement="top-start">
                    <span style="display: inline-block;maxHeight: 180px;padding:20px 0px;box-sizing: border-box;">{{scope.row.supplierFacts}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
        </el-table-column>

        <!-- CQS评分&Facts -->
        <el-table-column label="CQS评分" align="center">
          <el-table-column prop="cqsScore1" :label="'Food Brand Association|(whole company)'" :render-header="renderheader" align="center" min-width="120" >
            <template slot-scope="scope">
              <el-form-item  v-if="detailForm.status==2&&scope.$index!=detailForm.detailList.length-1&&scope.$index!=detailForm.detailList.length-2&&isCqs" :prop="'detailList.' + scope.$index + '.cqsScore1'"  :rules="scope.row.wt1?rules.cqsScore1:''" >
                <el-input  @input="scope.row.cqsScore1=scope.row.cqsScore1.replace(/[^\d]/g,'')" @blur="setCqsCurrent(scope.row,1)" v-model="scope.row.cqsScore1" :disabled="scope.row.wt1?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
              <span v-else>{{scope.row.cqsScore1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cqsScore2" :label="'Product Safety|(McDssupplyonly)'" :render-header="renderheader" align="center" min-width="120" >
            <template slot-scope="scope">
              <el-form-item v-if="detailForm.status==2&&scope.$index!=detailForm.detailList.length-1&&scope.$index!=detailForm.detailList.length-2&&isCqs"  :prop="'detailList.' + scope.$index + '.cqsScore2'"  :rules="scope.row.wt2?rules.cqsScore2:''" >
                <el-input @input="scope.row.cqsScore2=scope.row.cqsScore2.replace(/[^\d]/g,'')" @blur="setCqsCurrent(scope.row,2)" v-model="scope.row.cqsScore2" :disabled="scope.row.wt2?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
              <span v-else>{{scope.row.cqsScore2}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="!isSupplier" prop="cqsFacts" label="Facts" align="center" width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-form-item v-if="detailForm.status==2&&scope.$index!=detailForm.detailList.length-1&&scope.$index!=detailForm.detailList.length-2&&isCqs"  :prop="'detailList.' + scope.$index + '.cqsFacts'"  :rules="rules.cqsFacts" >
                <el-input class="stretchNone"  type="textarea" maxlength="1000"  :autosize="{ minRows: 4, maxRows: 4}" :rows="4"  v-model="scope.row.cqsFacts" style="width:100%">
                </el-input>
                <i v-if="scope.row.parentId?true:false"  @click.stop="openCqsDialog(scope.row,scope.$index)" style="position:absolute;right:10px;bottom:10%" class="el-icon-edit-outline"></i>
                <!-- <el-input  v-model="scope.row.supplierFacts"  placeholder="请输入内容" type="textarea" maxlength="1000" show-word-limit :rows="3" :autosize="{minRows:3}"></el-input> -->
              </el-form-item>
              <el-tooltip v-else class="item" effect="dark" :content="scope.row.cqsFacts" placement="top-start">
                <span style="display: inline-block;maxHeight: 180px;padding:20px 0px;box-sizing: border-box;">{{scope.row.cqsFacts}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-form>


      <!-- <el-row  style="margin-top:15px;height:100px;">
        <el-col :span="24" style="height:100%;">
            <table class="table-d">
                <tr>
                    <td>Total</td>
                    <td>{{detailForm.scoreTotal1}}</td>
                    <td>{{detailForm.scoreTotal2}}</td>
                </tr>
                <tr>
                    <td>级别</td>
                    <td>{{detailForm.scoreGrade1}}</td>
                    <td>{{detailForm.scoreGrade2}}</td>
                </tr>
            </table>
        </el-col>
      </el-row> -->

      <div class="handle-box">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">附件</p>
        </div>
          <el-button v-acl="RMC_PROT_SCORE_UPLOAD" v-if="(detailForm.status==1||detailForm.status==3)&&isSet" size="small" type="primary" @click="openFile">
              {{$t('common.selectFile')}}
          </el-button>
        <!-- <el-upload v-acl="RMC_PROT_SCORE_UPLOAD" v-if="detailForm.status==1||detailForm.status==3" style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
            <el-button slot="trigger" size="small" type="primary">
                {{$t('common.selectFile')}}
            </el-button>
        </el-upload> -->
        <el-table ref="plxTable" :data="fileTable" @selection-change="selectionChange" max-height="500" show-overflow="ellipsis" highlight-current-row>
            <el-table-column align="center" label="附件名称"   prop="documentName">
            <template slot-scope="scope">
                <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
            </template>
            </el-table-column>
            <el-table-column label="附件描述" align="center" prop="docComments">
              <template  slot-scope="scope">
                  <el-tooltip  class="item" effect="dark" :content="scope.row.docComments" placement="top-start">
                      <span style="display: inline-block;maxHeight: 80px;padding:10px 0px;box-sizing: border-box;">{{scope.row.docComments}}</span>
                  </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="上传人" align="center" prop="userName"></el-table-column>
            <el-table-column label="上传时间" align="center" prop="createDate"></el-table-column>
            <el-table-column label="操作" align="center" prop="updateDate" v-if="(detailForm.status==1||detailForm.status==3)&&isSet">
                <template v-slot="scope">
                    <i class="el-icon-delete" style="color: red;" @click="delFile(scope.row)"></i>
                </template>
            </el-table-column>
        </el-table>
      </div>


    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <uploadFile v-if="dialogVisible" @close="handleClose" :headerData="detailForm" ></uploadFile>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="addDialog"
      width="60%"
      :before-close="closeFactsDialog">
      <div slot="title" class="header-title">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">Facts填写</p>
        </div>
      </div>
      <factsDialog v-if="addDialog" @closeFacts="closeAddDialog" :factsInfo="factsInfo" :factsType="factsType"></factsDialog>
    </el-dialog>

    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import commonFunction from "@/utils/dataTableUtils";
import inventoryList from '@/components/page/RMC/Protein/rmcDrugDosage/inventoryList'
import aslApi from "@/api/rmcProtein/asl"; 
import QBRApi from "@/api/QBR/index";
import rmcGrade from '@/api/rmcProtein/rmcGrade';
import { fileService } from "@/api/common/file-utils"
import uploadFile from './dialog/uploadFile'
import factsDialog from '@/components/page/RMC/Protein/rmcScore/dialog/factsDialog'
import commonFun from "@/utils/commonFun";




export default {
  name: '',
  components: {
    inventoryList,
    IcSelect,
    uploadFile,
    factsDialog
  },
  data() {
    return {
      isSupplier: commonFun.isSupplier(),
      isCqs: commonFun.havePermission("RMC_PROT_SCORE_APPROVE"),
      isSet:false,
      factsIndex:"",
      factsInfo:{},
      factsType: "",
      addDialog:false,
      userID:localStorage.getItem("ms_userId"),
      category3List:[],
      allDate:[],
      fileTable:[],
      tableData:[],
      statusList: [],
      ownershipOptions:[{
            name:"VI",
            code:"VI",
        },{
            name:"SA",
            code:"SA",
        },{
            name:"ASL",
            code:"ASL",
        }],
        domesticOrOverseas:[],
        dialogVisible:false,
        identity:localStorage.getItem('ms_emplFlag'),
        categoryList3: [],
        detailForm: {},
        showDetailDialog:false,
        totalCount:"",
        cqsFirstScore: false,          // CQS首次进行评分
        rules:{
          oddNo: [
            { required: true, message: '请输入单号', trigger: 'blur' }
          ],
          aslGroupName: [
            { required: true, message: '请选择ASL Group', trigger: 'change' }
          ],
          aslName: [
            { required: true, message: '请输入ASL', trigger: 'blur' }
          ],
          domesticOrOverseasView: [
            { required: true, message: '请选择国内/国外', trigger: 'change' }
          ],
          supplierScore1:[
              { required: true, message: '请输入Score1', trigger: 'blur' }
          ],
          supplierScore2:[
              { required: true, message: '请输入Score2', trigger: 'blur' }
          ],
          supplierFacts:[
              { required: true, message: '请输入Facts', trigger: 'blur' }
          ],

          cqsScore1:[
            { required: true, message: '请输入Score1', trigger: 'blur' }
          ],
          cqsScore2:[
            { required: true, message: '请输入Score2', trigger: 'blur' }
          ],
          cqsFacts:[
            // { required: true, message: '请输入Facts', trigger: 'blur' }
          ],
        },
    }
  },
  created() {
    let functions = store.state.main.functions;
    if(functions.indexOf('RMC_PROT_SCORE_SAVE')!=-1||functions.indexOf('RMC_PROT_SCORE_SUBMIT')!=-1){
      this.isSet=true
    }
    console.log('functionsfunctions',functions)
    this.getStatusList()
    this.getAllDate()
    this.getCategory3Lists()
    if(this.$route.query.id){
      this.queryData();
    }
  },
  methods: {
    handleClose(){
      this.dialogVisible=false
      this.getFileList()
    },
    openFile(){
      this.dialogVisible=true
    },
    queryData() {
      rmcGrade.getDetailInfo(this.$route.query.id).then((res)=>{
          if(res.code==200){
            res.data.detailList.splice(0,1)
            if(res.data.cqsScoreGrade === null && res.data.cqsScoreTotal1 === null && res.data.cqsScoreTotal2 === null) {
              this.cqsFirstScore = true;
            } else {
              this.cqsFirstScore = false;
            }
            res.data.detailList.forEach((v)=>{
              if(this.cqsFirstScore && res.data.status == 2) {
                v.cqsFacts = v.lastCqsFacts;
                v.cqsScore1 = v.lastCqsScore1;
                v.cqsScore2 = v.lastCqsScore2;
              }
              if(!v.wt1){
                v.supplierScore1=''
                v.cqsScore1=''
              }
              if(!v.wt2){
                v.supplierScore2=''
                v.cqsScore2=''
              }
            })
            this.detailForm=res.data;
            let scoreObj={
              standard5:"Total",
              supplierScore1:res.data.scoreTotal1,
              supplierScore2:res.data.scoreTotal2,

              cqsScore1: res.data.cqsScoreTotal1,
              cqsScore2: res.data.cqsScoreTotal2
            }
            let ratingObj={
              standard5:"级别",
              supplierScore1:res.data.scoreGrade1,
              // supplierScore2:res.data.scoreGrade2,

              cqsScore1: res.data.cqsScoreGrade
            }
            this.detailForm.detailList.push(scoreObj)
            this.detailForm.detailList.push(ratingObj)
            this.getFileList()
          }else{
            this.$message.error(res.msg)
          }
      })
    },
    closeFactsDialog(){
      this.addDialog=false
    },
    closeAddDialog(val){
      if(val){
        if(this.factsType === "supplier") {
          this.detailForm.detailList[this.factsIndex].supplierFacts=val
        } else {
          this.detailForm.detailList[this.factsIndex].cqsFacts=val
        }
      }
      this.addDialog=false
    },
    openDialog(row,index){
      this.factsIndex=index
      this.factsInfo=row
      this.factsType = "supplier";
      this.addDialog=true
    },
    openCqsDialog(row,index) {
      this.factsIndex=index
      this.factsInfo=row
      this.factsType = "cqs";
      this.addDialog=true
    },
    delFile(row){
        if(row.createBy!=this.userID){
          this.$message.error('只能上传人操作附件')
        }else{
          // if(this.detailForm.status==1||this.detailForm.status==3){
            fileService.deleteFile(row.tmDocumentId).then(res => {
              if(res.code==200){
                this.$message.success('删除成功')
                this.getFileList()
              }else{
                this.$message.error(res.msg)
              }
            });
          // }else{
          //   this.$message.error("已发布状态无法删除附件")
          // }
          
        }
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.categoryList3 = []
      QBRApi.getCategoryLists({ categoryLevel: 3, category2Codes: this.detailForm.category2CodesList }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    // 供应商保存
    saveData(formName){
      let arr=[]
      let newArr=this.detailForm.detailList.filter((a)=>{
        return a.parentId
      })
      newArr.forEach((v,i)=>{
        let obj={}
        obj.ttRmcProteinScoreDetailId=v.ttRmcProteinScoreDetailId
        obj.supplierFacts=v.supplierFacts
        obj.supplierScore1=Number(v.supplierScore1)
        obj.supplierScore2=Number(v.supplierScore2)

        // obj.cqsFacts=v.cqsFacts
        // obj.cqsScore1=Number(v.cqsScore1)
        // obj.cqsScore2=Number(v.cqsScore2)
        arr.push(obj)
      })
      let params={
        scoreBody:arr
      }
      rmcGrade.saveScoreInfo(params,this.$route.query.id).then((res)=>{
          if(res.code==200){
            this.$message.success('保存成功')
            this.queryData()
          }else{
            this.$message.error(res.msg)
          }
      })
    },
    // 供应商提交
    submitData(formName){
        this.$refs[formName].validate((valid) => {
            if (valid) {
              let arr=[]
              let newArr=this.detailForm.detailList.filter((a)=>{
                return a.parentId
              })
              newArr.forEach((v,i)=>{
                let obj={}
                obj.ttRmcProteinScoreDetailId=v.ttRmcProteinScoreDetailId
                obj.supplierFacts=v.supplierFacts
                obj.supplierScore1=Number(v.supplierScore1)
                obj.supplierScore2=Number(v.supplierScore2)

                // obj.cqsFacts=v.cqsFacts
                // obj.cqsScore1=Number(v.cqsScore1)
                // obj.cqsScore2=Number(v.cqsScore2)
                arr.push(obj)
              })
              let params={
                scoreBody:arr
              }
              rmcGrade.saveScoreInfo(params,this.$route.query.id).then((res)=>{
                  if(res.code==200){
                    rmcGrade.appraise(this.$route.query.id).then((res)=>{
                        if(res.code==200){
                          this.$message.success('提交成功')
                          this.queryData()
                          this.$router.go(-1)
                        }else{
                          this.$message.error(res.msg)
                        }
                    })
                  }else{
                    this.$message.error(res.msg)
                  }
              })
            } else {

              return false;
            }
        });
    },
    getAllDate(){
      rmcGrade.getAllDate().then((res)=>{
        this.allDate=res.resultData
      })
    },
    renderheader(h, { column, $index }) {
      return h('span', {}, [
        h('span', {}, column.label.split('|')[0]),
        h('br'),
        h('span', {}, column.label.split('|')[1])
      ]);
    },
    routerBack(){
        this.$router.back();
    },
    // CQS评分保存
    cqsSave() {
      let arr=[]
      let newArr=this.detailForm.detailList.filter((a)=>{
        return a.parentId
      })
      newArr.forEach((v,i)=>{
        let obj={}
        obj.ttRmcProteinScoreDetailId=v.ttRmcProteinScoreDetailId
        obj.supplierFacts=v.supplierFacts
        obj.supplierScore1=Number(v.supplierScore1)
        obj.supplierScore2=Number(v.supplierScore2)

        obj.cqsFacts=v.cqsFacts
        obj.cqsScore1=Number(v.cqsScore1)
        obj.cqsScore2=Number(v.cqsScore2)
        arr.push(obj)
      })
      let params={
        scoreBody:arr
      }
      rmcGrade.saveScoreInfo(params,this.$route.query.id).then((res)=>{
        if(res.code==200){
          this.$message.success('保存成功')
          this.queryData()
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    // CQS批准
    approve(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr=[]
          let newArr=this.detailForm.detailList.filter((a)=>{
            return a.parentId
          })
          newArr.forEach((v,i)=>{
            let obj={}
            obj.ttRmcProteinScoreDetailId=v.ttRmcProteinScoreDetailId
            obj.supplierFacts=v.supplierFacts
            obj.supplierScore1=Number(v.supplierScore1)
            obj.supplierScore2=Number(v.supplierScore2)

            obj.cqsFacts=v.cqsFacts
            obj.cqsScore1=Number(v.cqsScore1)
            obj.cqsScore2=Number(v.cqsScore2)
            arr.push(obj)
          })
          let params={
            scoreBody:arr
          }
          rmcGrade.saveScoreInfo(params,this.$route.query.id).then((res)=>{
            if(res.code==200){
              // this.$message.success('保存成功')
              // this.queryData()
              rmcGrade.approvalBatch([this.detailForm.ttRmcProteinScoreId]).then((res2)=>{
                if(res2.code==200){
                  this.$message.success('批准成功')
                  this.queryData()
                }else{
                  this.$message.error(res2.msg)
                }
              })
            }else{
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }){
      if(rowIndex==this.detailForm.detailList.length-1){
        if(columnIndex===8||columnIndex===11){
          return [1,2]
        }else if(columnIndex===9||columnIndex===12){
          return {rowspan:0,colspan:0}
        }
      }
      if(rowIndex==this.detailForm.detailList.length-2){
        // if(columnIndex===8){
        //   return [1,3]
        // }else if(columnIndex===11){
        //   return [1,2]
        // }
      }
    },
    getFileList() {
        let attachment = {};
        attachment.tsReckindId = "RMC_PROTEIN_SCORE";
        attachment.tsRecId = this.detailForm.ttRmcProteinScoreId;
        fileService.getFileList(attachment).then(res => {
          console.log("文件的列表===========",res)
          this.fileTable = res;
        });
    },
    // CQS退回
    rejectBatch(){
      this.$prompt('', '请填写退回原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValidator: (value) => {  
            if(!value) {
              return '退回原因不能为空！';
            }
          },
        }).then(({ value }) => {
          let params={
            idList:[this.detailForm.ttRmcProteinScoreId],
            rejectReason:value
          }
          rmcGrade.rejectBatch(params).then((res)=>{
            if(res.code==200){
              this.$message.success('退回成功')
              this.queryData()
            }else{
              this.$message.error(res.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
    },
    setCurrent(row,index){
      if(index==1){
        if(row.supplierScore1>row.maxValue){
          this.$message.error('输入的数值不能超过最大分数,请重新输入')
          this.$set(row,'supplierScore1',"")
          return 
        }
      }else{
        if(row.supplierScore2>row.maxValue){
          this.$message.error('输入的数值不能超过最大分数,请重新输入')
          this.$set(row,'supplierScore2',"")
          return 
        }
      }
    },
    setCqsCurrent(row,index){
      if(index==1){
        if(row.cqsScore1>row.maxValue){
          this.$message.error('输入的数值不能超过最大分数,请重新输入')
          this.$set(row,'cqsScore1',"")
          return
        }
      }else{
        if(row.cqsScore2>row.maxValue){
          this.$message.error('输入的数值不能超过最大分数,请重新输入')
          this.$set(row,'cqsScore2',"")
          return
        }
      }
    },
    onDownload(row){
        fileService.downloadFile(row).then((res) => { })
    },
    getStatusList(){
      rmcGrade.getStatusList().then((res)=>{
        this.statusList=res.resultData
      })
    },
    getCategory3Lists() {
      aslApi.getCategory3(['rmc.RmcCategory3','rmc.RmcProteinAslOwnership','rmc.RmcDomesticOrOverseas','rmc.RmcProteinAslStatus']).then((res)=>{
       if(res.code==200){
          let newArr=[]
          let domesticOrOverseas=[]
          let newObj=res.data
          for(let item in newObj){
            if(item=='rmc.RmcCategory3'){
              newArr=newObj[item]
            }
            if(item=='rmc.RmcDomesticOrOverseas'){
              domesticOrOverseas=newObj[item]
            }
          }
          this.category3List=newArr.filter((v)=>{
            return v.cascadeKey=='protein'
          })
          this.domesticOrOverseas=domesticOrOverseas
        }else{
          this.$message.error(res.msg)
        }
        console.log("获取的列表====",res)
      })
    },
    
  },
  extends: commonFunction
}
</script>
<style scoped >
/deep/ .el-table__row td .cell{
  max-height: 160px;
}
/deep/ .el-table th>.cell{
  /* position: relative; */
  word-wrap: break-word;
  word-break: normal;
  text-overflow: auto;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  box-sizing: border-box;
}
/deep/ .el-table__row td  .cell{
  white-space:normal;
  word-wrap: break-word ;
  word-break: normal ;
}




/deep/ .stretchNone .el-textarea__inner{
    position:relative;
    resize: none;
}
/deep/ .el-table__body-wrapper .el-form-item__content{
  margin-left: 0px !important;
}
/deep/ .setTable .el-table__body-wrapper  .el-form-item--mini.el-form-item, .setTable .el-form-item--small.el-form-item{
  margin: 15px 0px !important;
}
.searchForm .el-col{
    margin-top: 10px;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
